import { styled } from '@lichtblick/styled';

export const AuthBackground = styled.div`
  align-items: center;
  background: var(--colors-blue-20);
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  padding: 2rem;
  width: 100vw;
`;

export const AuthCard = styled.div`
  align-items: center;
  background: var(--colors-white);
  border-radius: var(--border-radius-s);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l);
  justify-content: center;
  padding: 4.5rem 3rem;
  text-align: center;
  width: 38.75rem;
`;
